import React from 'react';
import './LogoHeader.css';

interface LogoHeaderProps {
  className?: string;
}

const LogoHeader: React.FC<LogoHeaderProps> = ({ className }) => {
  const merged = ['intro-logo-header', className].filter(Boolean).join(' ');
  return (
    <header className={merged}>
      <img
        src="/xoxo-beverages-rectangular.png"
        alt="XOXO Beverages"
        className="intro-logo-image"
      />
    </header>
  );
};

export default LogoHeader;
